@use '@css/variables';


$gap: 25px;

.characteristics
{
  background-color: var(--beigelight);

  border-radius: 6px;
  padding: 25px;

  .items {
    display: grid;

    grid-template-columns: 1fr;
    gap: $gap;
    margin-bottom: $gap;


    .item {
      border-bottom: 1px solid rgba(151, 144, 121, 0.3);
      display: flex;
      gap: 20px;
      padding-bottom: 20px;

      .icon {
        flex-basis: 30px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: var(--beigedarker);
      }

      .content {

        flex-grow: 1;

        .title {

          color: var(--beigedarker);
          font-size: 14px;
          line-height: 24px;
        }

        .text {
          font-weight: bold;
        }
      }

    }
  }
}


@media only screen and (min-width: variables.$md-breakpoint) {
  .characteristics
  {
    .items {
      grid-template-columns: 1fr 1fr;
    }
  }
}
